import { Injectable, Inject } from "@angular/core";
import OktaAuth from "@okta/okta-auth-js";
import { OKTA_AUTH } from "@okta/okta-angular";
import { ICurrentUser } from "@models/user-management/user";
import { AuthProviderEnum, IAuthStrategy } from "@models/core/auth";
import { AccessToken } from "@models/http/http-options";
import { UserRoleEnum } from "@models/user-management/user-role";

@Injectable({ providedIn: "root" })
export class OktaAuthService implements IAuthStrategy {
  constructor(@Inject(OKTA_AUTH) private oktaAuth: OktaAuth) {}

  async getCurrentUser(): Promise<ICurrentUser | null> {
    const isAuthenticated = await this.oktaAuth.isAuthenticated();
    if (isAuthenticated) {
      const user = await this.oktaAuth.getUser();

      return {
        id: user.sub,
        login: user.email || user.preferred_username,
        name: user?.name,
        permissionCodes: [],
        roleNames: [UserRoleEnum.BusinessPartner],
        homePageMenuItemUrl: "/equipments-bp-showcase",
      };
    }
    return null;
  }

  async isUserSignedIn(): Promise<boolean> {
    return this.oktaAuth.isAuthenticated();
  }

  async getToken(): Promise<string | undefined> {
    const isAuthenticated = await this.oktaAuth.isAuthenticated();
    if (isAuthenticated) {
      const accessToken = await this.oktaAuth.getAccessToken();
      if (accessToken) {
        localStorage.setItem(AccessToken, accessToken);
        localStorage.setItem("idp", AuthProviderEnum.Okta);
      }
      return accessToken ?? undefined;
    }
    return undefined;
  }

  async userInitiatedSignOut(): Promise<void> {
    return this.oktaAuth
      .signOut({ clearTokensBeforeRedirect: true })
      .then(() => {});
  }

  async getUserRoles(): Promise<string[] | undefined> {
    const isAuthenticated = await this.oktaAuth.isAuthenticated();
    if (isAuthenticated) {
      const user = await this.oktaAuth.getUser();
      const groups = Array.isArray(user.groups)
        ? user.groups.map((g: any) => (typeof g === "string" ? g : String(g)))
        : [];
      return [UserRoleEnum.BusinessPartner, ...groups];
    }
    return undefined;
  }
}
